// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-5m5","title":"styles_title__3P3nf"};